import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {PostOfficeState} from "@/interfaces/state";
import {PostOffice} from "@/interfaces/entity";
import {
    createPostOffice, deletePostOffice,
    listPostOffice,
    singlePostOffice,
    updatePostOffice
} from "@/modules/postoffices/services";
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {PostOfficeParams} from "@/modules/postoffices/params";

@Module({ dynamic: true, name: "postOffice", store })
class PostOfficeModule extends VuexModule implements PostOfficeState {
    data: IdMapper<PostOffice> = {};
    ids: string[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: PostOfficeParams = new PostOfficeParams();

    get postOffices() {
        return this.ids.map((id: string) => this.data[id]);
    }

    @Mutation
    private UPDATE_POST_OFFICE_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation
    private MAP_POSTOFFICE(payload: any) {
        const idMapper: IdMapper<PostOffice> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((service: PostOffice) => {
            idMapper[service.rowGuid!] = {...service, isDeleting: false};
            return service.rowGuid;
        });
        this.data = idMapper;
    }

    @Mutation
    private ADD_POSTOFFICE(payload: PostOffice) {
        if (!payload || this.ids.includes(payload.rowGuid) || this.data[payload.rowGuid]) return;
        this.ids = [ ...this.ids, payload.rowGuid ];
        this.data = { ...this.data, [payload.rowGuid]: {...payload, isDeleting: false} }
    }

    @Mutation
    private UPDATE_POSTOFFICE(payload: PostOffice) {
        if (!this.data[payload.rowGuid] || !this.ids.includes(payload.rowGuid)) return;
        this.data[payload.rowGuid] = { ...payload, isDeleting: false }
    }

    @Mutation
    private DELETE_POSTOFFICE(payload: PostOffice) {
        if (!this.data[payload.rowGuid] || !this.ids.includes(payload.rowGuid)) return;
        this.ids = this.ids.filter((id: string) => id !== payload.rowGuid);
        delete this.data[payload.rowGuid];
    }

    @Mutation
    private START_DELETE_POSTOFFICE(id: string) {
        this.data[id].isDeleting = true;
    }

    @Mutation
    private END_DELETE_POSTOFFICE(id: string) {
        this.data[id].isDeleting = false;
    }

    @Action({ rawError: true })
    public updatePostOfficeParams(payload: any) {
        this.UPDATE_POST_OFFICE_PARAMS(payload);
    }

    @Action({ rawError: true })
    public addPostOffice(payload: PostOffice) {
        this.ADD_POSTOFFICE(payload);
    }

    @Action({ rawError: true })
    public async createPostOffice(form: any) {
        const { data } = await createPostOffice(form);
        this.ADD_POSTOFFICE(data.data);
    }

    @Action({ rawError: true })
    public async listPostOffice(params: PostOfficeParams = new PostOfficeParams()) {
        const { data } = await listPostOffice(params);
        this.MAP_POSTOFFICE(data);
    }

    @Action({ rawError: true })
    public async singlePostOffice(id: string) {
        const { data } = await singlePostOffice(id);
        return data.data;
    }

    @Action({ rawError: true })
    public async updatePostOffice(dataReq: any) {
        const { data } = await updatePostOffice(dataReq.rowGuid, dataReq);
        this.UPDATE_POSTOFFICE(data.data);
    }

    @Action({ rawError: true })
    public async deletePostOffice(id: string) {
        this.START_DELETE_POSTOFFICE(id);
        const { data } = await deletePostOffice(id);
        this.END_DELETE_POSTOFFICE(id);
        this.DELETE_POSTOFFICE(data.data);
    }
}

export const PostOfficeStore = getModule(PostOfficeModule);